export const numberWithCommas = (val) => {
  if (val == null) {
    return;
  }

  if (val.toString() == "0") {
    return "0";
  }

  if (val == false) {
    return "0";
  }

  if (val == true) {
    return "1";
  }

  return val
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const wholeNumberWithCommas = (val) => {
  if (val == null) {
    return;
  }

  if (val == false) {
    return "0";
  }

  if (val == true) {
    return "1";
  }

  if (val.toString() == "0") {
    return "0";
  }

  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const numberToPercent = (input) => {
  if (input === null || isNaN(input)) return input;
  const num = Number(input);

  return num.toLocaleString("en-US", { style: "percent" });
};

export const sum = (rows, key) => rows.reduce((total, row) => total + (row[key] ?? 0), 0);
export const sumFloat = (rows, key) =>
  rows.reduce((total, row) => total + parseFloat(row[key] ?? 0), 0);
